
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import manualButton from '@/components/manual-button';
import sourceP from './manual-search/source-p';
import orderP from './manual-search/order-p';
import purchaseApplyP from "./manual-search/purchase-apply-p.vue"
import contactP from './manual-search/contact-p';
import SourcePagination from "./manual-search/source-pagination";
import expiresQueryP from "./manual-search/expires-query-p";

const _ = require('lodash');
class searchTab extends _{
constructor(name,list) {
super();
this.name = name;
this.list= _.cloneDeep(list);
}
}


export default {
name: "manual-search",
directives: {
TransferDom
},
components: {
SourcePagination,
Popup,
manualButton,
Datetime,
Group,
sourceP,
orderP,
expiresQueryP,
contactP,
purchaseApplyP

},
props:['config',"isTodo"],
data() {
return {
show:false,
checkedDtoList:[],
}
},

methods: {
cancel(){
this.$refs.checkManual.reload();
},
showpop(){
this.show = !this.show;
document.getElementsByTagName('body')[0].classList.add("noscroll");
},
closePop(){
this.checkedDtoList = this.$refs.checkManual.checkedDtoList;
this.$refs.checkManual.closeReset();
this.$emit('on-close',this.$refs.checkManual.checkedDtoList);
document.getElementsByTagName('body')[0].classList.remove("noscroll");
},
confirm(){
this.show=false;
}
},
mounted() {

},


}



// WEBPACK FOOTER //
// ./src/components/manual-search.vue